import { render, staticRenderFns } from "./FailObservePage.vue?vue&type=template&id=34cc1916&"
import script from "./FailObservePage.vue?vue&type=script&lang=js&"
export * from "./FailObservePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports